import { $, $$, on, doc } from './util.js';

/* 4. ARTICLE TOC + SCROLLSPY
   Built client-side from the rendered article headings, because the body
   comes out of the CMS as free HTML — there is no server-side heading list. */
/* Slug rule, shared with anything that has to produce a heading id that this
   module would agree with (module-reference.js re-renders the article body and
   must not invent different anchors). */
export function headingSlug(text) {
	return text.trim().toLowerCase()
		.replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').slice(0, 60) || 'section';
}

export function initToc() {
	var rail = $('#tocList');
	var article = $('.article-body');
	if (!rail || !article) { return; }

	/* Idempotent: callers re-run this after replacing the article body, and
	   without clearing first the rail would accumulate a second set of links. */
	rail.innerHTML = '';

	/* Headings from EVERY .article-body in the article, in document order. A
	   page whose text is one Richtext area has one body and reads as before; a
	   guide page's text is a collection of components, each Richtext chunk (and
	   each code sample) its own .article-body, and reading only the first one
	   listed the opening chunk's headings alone. */
	var scope = $('.article-wrap') || doc;
	var heads = $$('.article-body h2, .article-body h3', scope).filter(function (h) { return h.textContent.trim(); });

	/* A rail with data-toc-min="2" stays empty below that many headings: a
	   release with only its fixes has nothing to jump between. The column
	   keeps its width, so the article does not move between pages. */
	var wrap = rail.closest('.toc-wrap');
	var min = wrap ? parseInt(wrap.getAttribute('data-toc-min'), 10) || 0 : 0;
	if (wrap) { wrap.classList.toggle('toc-none', min > 0 && heads.length < min); }
	if (min > 0 && heads.length < min) { return; }

	if (!heads.length) {
		rail.innerHTML = '<p class="toc-empty">No sections on this page.</p>';
		return;
	}

	var used = {};
	var links = heads.map(function (h) {
		if (!h.id) {
			var base = headingSlug(h.textContent);
			used[base] = (used[base] || 0) + 1;
			h.id = used[base] > 1 ? base + '-' + used[base] : base;
		}
		var a = doc.createElement('a');
		a.className = 'toc-item' + (h.tagName === 'H3' ? ' sub' : '');
		a.href = '#' + h.id;
		a.textContent = h.textContent.trim();
		rail.appendChild(a);
		return { a: a, h: h };
	});

	function spy() {
		var top = window.pageYOffset + 120;
		var current = links[0];
		for (var i = 0; i < links.length; i++) {
			if (links[i].h.offsetTop <= top) { current = links[i]; } else { break; }
		}
		links.forEach(function (l) { l.a.classList.toggle('active', l === current); });
	}

	var ticking = false;
	on(window, 'scroll', function () {
		if (ticking) { return; }
		ticking = true;
		window.requestAnimationFrame(function () { spy(); ticking = false; });
	});
	spy();

	/* Honour a fragment that was in the URL before these ids existed.

	   The headings come out of the CMS with no id, so every anchor on the page
	   is assigned above — but the browser resolves location.hash while parsing,
	   long before this runs. It therefore finds nothing and leaves the reader at
	   the top: /developer-docs/entities/books/book#frontend simply did not
	   go to Frontend. Re-applying the jump once the ids exist is the only way to
	   make a shared or bookmarked deep link land.

	   Guarded by "did the user already scroll", so this cannot yank the page
	   from under someone who started reading during the fetch. */
	applyHash();
}

/* Exported so a module that replaces the article body can re-apply the jump
   after its own re-render, by which point the original attempt has been lost. */
export function applyHash() {
	var hash = window.location.hash;
	if (!hash || hash.length < 2) { return; }
	if (window.pageYOffset > 40) { return; }

	var target;
	try {
		target = doc.getElementById(decodeURIComponent(hash.slice(1)));
	} catch (e) {
		target = doc.getElementById(hash.slice(1));
	}
	if (!target) { return; }

	// scrollIntoView rather than assigning location.hash again: re-assigning
	// would push a duplicate entry onto the history stack.
	target.scrollIntoView();
}
